module.exports = __webpack_public_path__ + "static/media/FLIP.8d20283b.jpg";